export default "__VITE_ASSET__BRj0oZ44__"